import React, {PropTypes} from "react";
import {Field, reduxForm} from "redux-form";
import MenuItem from "material-ui/MenuItem";
import {DatePicker, SelectField, TextField} from "redux-form-material-ui";

class PersonalInfo extends React.Component {

  constructor() {
    super();
  }

  render() {

    const {handleSubmit, reset} = this.props;
    return (
      <div className="col-md-12">
        <form onSubmit={handleSubmit(data=> {
          console.log(data);
          this.props.submitHandler(data);

        })}>
          <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
            <thead>
            <tr>
              <th cellPadding="0" colSpan="4">
                <span className="bold pull-left"> Personal Info</span>
                <span className="bold hrms-link pull-right"><a >
                     <button type="button" onClick={this.props.close}><i className="glyphicon glyphicon-remove"
                     ></i>Cancel</button></a></span>

                <span className="bold hrms-link pull-right"><a type="submit">
                     <button type="submit"><i className="glyphicon glyphicon-saved"
                     ></i>Save</button></a></span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style={{align: 'left', width: '18%'}}>Name :</td>
              <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                    <Field
                      name="name"
                      component={TextField}/></span>
              </td>
              <td style={{align: 'left', width: '18%'}}>Spouse Name :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                     <Field
                       name="spouseName"
                       component={TextField}/>
                  </span>
              </td>
            </tr>
            <tr>
              <td style={{align: 'left'}}>Date of birth :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                    <Field

                      name="empDOB"
                      autoOk={true}
                      component={DatePicker}/>
                  </span>
              </td>
              <td style={{align: 'left'}}>Anniversary :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText"><Field
                    name="empAnniversary"
                    autoOk={true}
                    component={DatePicker}/></span>
              </td>
            </tr>


            <tr>
              <td style={{align: 'left'}}>Father Name :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText"><Field
                    name="fatherName"
                    component={TextField}/></span>
              </td>
              <td style={{align: 'left'}}>Mother Name :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">
                    <Field
                      name="motherName"
                      component={TextField}/></span>
              </td>
            </tr>

            <tr>
              <td style={{align: 'left'}}>Marital Status :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                    <Field
                      name="maritalStatus"
                      component={SelectField}>
                     <MenuItem value='S' primaryText='Single'/>
                     <MenuItem value='M' primaryText='Married'/>
                     <MenuItem value='W' primaryText='Widow'/>
                     <MenuItem value='R' primaryText='Widower'/>

                  </Field></span>
              </td>
              <td style={{align: 'left'}}>Gender :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">
                    <Field
                      name="gender"
                      component={SelectField}>
                     <MenuItem value='M' primaryText='Male'/>
                     <MenuItem value='F' primaryText='Female'/>

                  </Field>
                  </span>
              </td>
            </tr>
            <tr>
              <td style={{align: 'left'}}>Child Name 1 :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                    <Field
                      name="childName1"
                      component={TextField}/></span>
              </td>
              <td style={{align: 'left'}}>Child Name 2 :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">
                       <Field
                         name="childName2"
                         component={TextField}/></span>
              </td>
            </tr>
            </tbody>
          </table>
        </form>


      </div>
    );
  }
}

PersonalInfo.propTypes = {};

export default reduxForm({
  form: 'personalInfo',


})(PersonalInfo)






/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/EmployeeSS/Tables/PersonalInfoEdit.js
 **/